(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/react-help-utils/assets/javascripts/wrap-view.js') >= 0) return;  svs.modules.push('/components/utils/react-help-utils/assets/javascripts/wrap-view.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

(function (svs) {
  'use strict';

  var _React = React,
    Component = _React.Component;
  svs.utils.reactHelpUtils.wrapView = function (View) {
    var eventHandlers = {
      add: function add(model, callback) {
        model.on('add', function (event) {
          var key = 'attributes';
          callback(key, event.attributes);
        });
      },
      remove: function remove(model, callback) {
        model.on('remove', function (event) {
          var key = 'attributes';
          callback(key, event.attributes);
        });
      },
      change: function change(model, callback) {
        model.on('change', function (event) {
          var changed = event.changed;

          for (var key in changed) {
            if (Object.prototype.hasOwnProperty.call(changed, key)) {
              callback(key, changed[key]);
            }
          }
        });
      }
    };
    var initEventHandlers = function initEventHandlers(events, model) {
      for (var key in events) {
        if (Object.prototype.hasOwnProperty.call(events, key) && eventHandlers[key]) {
          var eventHandler = eventHandlers[key];
          var callback = events[key];
          eventHandler(model, callback);
        }
      }
    };
    var isEqual = function isEqual(nextProps, props) {
      return JSON.stringify(nextProps) === JSON.stringify(props);
    };

    var BackboneWrapper = function (_Component) {
      function BackboneWrapper() {
        _classCallCheck(this, BackboneWrapper);
        return _callSuper(this, BackboneWrapper, arguments);
      }
      _inherits(BackboneWrapper, _Component);
      return _createClass(BackboneWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var events = this.props.events;
          var options = this.props.options;
          if (events && options) {
            var model = options.itemModel || options.configModel || options.model;
            if (!model) {
              throw new Error('A model is required to handle events');
            }
            initEventHandlers(events, model);
          }
          this.view = options ? new View(options) : new View();
          var $el = $(this.el);
          $el.html(this.view.render().el);
          if (this.view.triggerMethod) {
            this.view.triggerMethod('attach');
            this.view.triggerMethod('show');
          }
        }

      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          if (this.view.updateOptions) {
            if (!isEqual(nextProps, this.props)) {
              this.view.updateOptions(nextProps.options);
            }
          }
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
          return this.props.shouldUpdate;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.view.close) {
            this.view.close();
          }
          if (this.view.destroy) {
            this.view.destroy();
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this = this;
          return React.createElement("div", {
            className: this.props.className,
            ref: function ref(e) {
              _this.el = e;
            }
          });
        }
      }]);
    }(Component);
    BackboneWrapper.defaultProps = {
      shouldUpdate: false
    };
    return BackboneWrapper;
  };
})(svs);

 })(window);